import React, {useEffect} from 'react';
import {connect, ConnectedProps} from 'react-redux';
import {useHistory} from 'react-router-dom';

import {ElementPosition} from 'FoalProfile/models/IElementPosition';
import FoalParentMainInfo from 'FoalProfile/components/FoalProfileHeader/FoalParent/parts/FoalParentMainInfo';
import FoalParentAbilities from 'FoalProfile/components/FoalProfileHeader/FoalParent/parts/FoalParentAbilities';
import {IFoalParent} from 'FoalProfile/models/IFoalParent';
import {IAppState} from 'Common/store/IAppState';
import {actions, selectors} from 'FoalProfile/store/buildFoal/index';
import withDynamicModules from 'Common/helpers/withDynamicModules';
import {BuildFoalModule} from 'FoalProfile/store/buildFoal/buildFoalModule';
import {Nullable} from 'Common/types';

interface IExternalProps {
  parentId?: string;
  hasPartner: boolean;
  position: ElementPosition;
  changePartnerLink: Nullable<string>;
  onSuccess(parent: IFoalParent): void;
}

type IConnected = ConnectedProps<typeof connector>;

type AllProps = IExternalProps & IConnected;

const FoalParent = (props: AllProps) => {
  const {position, parentId, hasPartner, changePartnerLink, onSuccess} = props;
  const {parent, parentLoading, getParent} = props;

  const history = useHistory();

  useEffect(() => {
    if (parentId && parentId !== '0') {
      getParent(+parentId, position);
    }
  }, [parentId, position, getParent]);

  useEffect(() => {
    if (parent) {
      onSuccess(parent);
    }
  }, [parent, onSuccess]);

  const path = history.location.pathname.endsWith('/')
    ? history.location.pathname.slice(0, -1)
    : history.location.pathname;

  const onSelectHorse = (horseId: number) => {
    if (parentId !== '0' && history.location.pathname.includes(`${parentId}`)) {
      history.push(`${path.replace(`${parentId}`, `${horseId}`)}`);
      return;
    }

    if (hasPartner) {
      history.push(`${path.replace('/0', `/${horseId}`)}`);
      return;
    }

    if (position === ElementPosition.Left) {
      history.push(`${path}/${horseId}/0`);
    } else {
      history.push(`${path}/0/${horseId}`);
    }
  };

  return (
    <div className="d-flex flex-column w-50">
      <FoalParentMainInfo
        isLoading={parentLoading.isRequesting}
        parent={parent}
        elementPosition={position}
        linkAnotherPartner={changePartnerLink || ''}
        onSelectAnotherPartner={onSelectHorse}
      />
      <FoalParentAbilities abilities={parent?.abilities} position={position} />
    </div>
  );
};

const firstParentMapStateToProps = (state: IAppState) => ({
  parent: selectors.selectFirstParent(state),
  parentLoading: selectors.selectCommunication(state, 'firstParentLoading'),
});

const secondParentMapStateToProps = (state: IAppState) => ({
  parent: selectors.selectSecondParent(state),
  parentLoading: selectors.selectCommunication(state, 'secondParentLoading'),
});

const mapStateToProps = (state: IAppState, {position}: IExternalProps) =>
  position === ElementPosition.Left ? firstParentMapStateToProps : secondParentMapStateToProps;

const mapDispatchToProps = {
  getParent: actions.getParent,
};

const connector = connect(mapStateToProps, mapDispatchToProps);
export default withDynamicModules(connector(FoalParent), BuildFoalModule);
